import { FC } from 'react';
import { useLoaderData } from 'react-router-dom';

import { ITabState } from '../../../states/tabState.model';
import { CRMNotesTable } from './components/crmNotesTable.component';

export const Crm: FC = () => {
  const { customerCRMNotes, customerId } = useLoaderData() as ITabState;
  return <CRMNotesTable {...{ crmNotes: customerCRMNotes, customerId }} />;
};
